/** Feature names exactly as the FeatureAccess API sends and accepts them. */
export enum FeatureAccessFeature {
  TIME_REGISTRATION = 'TimeRegistration',
  AVAILABILITIES = 'Availabilities',
  DATA_WIZARD = 'DataWizard',
  JOB_APPLICANTS = 'JobApplicants',
}
